/* eslint-disable react/no-array-index-key */

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import Tab from './Tab';
import './FeedFloTabs.scss';
/**
 * interface TabData {
 *   title: string; // The display text for the tab
 *   link: string; // The URL path segment to match for this tab
 *   content?: React.ReactNode; // Optional content to display in the tab
 *   contentLeft?: React.ReactNode; // Optional left-aligned content
 *   contentRight?: React.ReactNode; // Optional right-aligned content
 *   className?: string; // Optional custom CSS class for the tab
 *   contentLeftClassName?: string; // Optional CSS class for left content
 *   contentRightClassName?: string; // Optional CSS class for right content
 *   contentClassName?: string; // Optional CSS class for main content
 *   spacerClassName?: string; // Optional CSS class for spacer element
 * }
 */

function FeedFloTabs({
  className = '',
  tabData = [], //  see the "interface TabData" comment above for expected shape
  defaultSelected = 0,
  onClick = () => {},
  tabClassName = '',
  growerClassName = '',
}) {
  const location = useLocation();

  const [currSelectedIndex, setCurrSelectedIndex] = useState(defaultSelected);

  useEffect(() => {
    // Extract all segments of the URL path to determine the current tab
    // This works for any URL structure, including nested routes
    const pathSegments = location.pathname.split('/').filter(Boolean);

    // Find the tab by matching against any path segment (not just the last one)
    // This handles cases like both /barn/:id/overview and /orgs/:id/users/:id where we want to match 'users'
    const searchedIndex = tabData.findIndex(({ link }) => {
      // Extract the last segment from the link for comparison
      const linkSegments = link.split('/').filter(Boolean);
      const lastLinkSegment = linkSegments.at(-1);
      return pathSegments.includes(lastLinkSegment);
    });
    const selectedIndex = searchedIndex === -1 ? defaultSelected : searchedIndex;

    setCurrSelectedIndex(selectedIndex);
  }, [tabData, location.pathname, defaultSelected]);

  const onTabClick = (i) => {
    setCurrSelectedIndex(i);
    onClick(i);
  };

  return (
    <div className={`FeedFloTabs ${className}`}>
      {tabData.map((tab, i) => {
        return (
          <Tab
            key={i}
            index={i}
            title={tab.title}
            link={tab.link}
            selected={currSelectedIndex === i}
            onClick={onTabClick}
            content={tab.content}
            contentLeft={tab.contentLeft}
            contentRight={tab.contentRight}
            className={tab.className || tabClassName}
            contentLeftClassName={tab.contentLeftClassName}
            contentRightClassName={tab.contentRightClassName}
            contentClassName={tab.contentClassName}
            spacerClassName={tab.spacerClassName}
          />
        );
      })}
      <div className={`grower ${growerClassName}`} />
    </div>
  );
}

FeedFloTabs.propTypes = {
  tabData: PropTypes.array,
  className: PropTypes.string,
  tabClassName: PropTypes.string,
  growerClassName: PropTypes.string,
  onClick: PropTypes.func,
  defaultSelected: PropTypes.number,
};

export default FeedFloTabs;
